import React, { useEffect, useState } from "react";
import "../../assets/css/agent/tickets.scss";
import { Link, useHistory, useLocation } from "react-router-dom";
import axiosInstance from '../../environment/axiosInstance';
import moment from "moment";
import ReactPaginate from 'react-paginate';
import "../../assets/css/pagination.scss";
import { BsCircle } from "react-icons/bs";
import { AiOutlinePlus } from "react-icons/ai";
import Dropdown from 'react-bootstrap/Dropdown';
import { ToastContainer, toast } from 'react-toastify';

function AllTickets(props) {
    const history = useHistory();
    const [tickets, setTickets] = useState([]);
    const [ticketsCount, setTicketsCount] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [page, setPage] = useState(1);

    const toastError = (message) => {
        toast.error(message);
    }

    const toastSuccess = (message) => {
        toast.success(message);
    }

    const useQuery = () => {
        const { search } = useLocation();

        return React.useMemo(() => new URLSearchParams(search), [search]);
    }

    let searchParams = useQuery();

    useEffect(() => {
        let page = 1;

        if (searchParams.get("page")) {
            page = searchParams.get("page");
        }

        setPage(page);
        fetchTickets(page);
    }, [searchParams.get("page")]);

    const fetchTickets = (page) => {
        axiosInstance
            .get(process.env.REACT_APP_API_URL + "/support/business_owner/ticket?page=" + page)
            .then(response => {
                if (response.data) {
                    response.data.Data.docs.forEach(ticket => {
                        ticket.statusDropdownIsOpen = false;
                    });
                    setTickets(response.data.Data.docs);
                    setTicketsCount(response.data.Data.totalDocs);
                    setTotalPages(response.data.Data.totalPages);
                }
            });
    }

    const handlePageClick = (event) => {
        history.push("/dashboard/tickets?page=" + (event.selected + 1));
    }

    const onStatusClicked = (ticket_id) => {
        let p_tickets = Object.assign(tickets, []);

        p_tickets.map(ticket => {
            ticket.statusDropdownIsOpen = false;

            if (ticket._id == ticket_id) {
                ticket.statusDropdownIsOpen = true;
            }
        });

        setTickets(p_tickets);
    }

    const onStatusSelected = (ticket_id, status) => {
        axiosInstance
            .patch(process.env.REACT_APP_API_URL + "/support/business_owner/ticket/" + ticket_id, {
                ticket_status: status
            })
            .then(response => {
                if (response.data?.statusCode == 200) {
                    toastSuccess(response.data.message);
                    fetchTickets(searchParams.get("page"));
                    // let p_tickets = Object.assign(tickets, []);

                    // p_tickets.map(ticket => {
                    //     if (ticket._id == ticket_id) {
                    //         ticket.ticket_status = status;
                    //     }
                    // });

                    // setTickets(p_tickets);
                }
            })
    }

    return (
        <div>
            <div className="tickets-content">
                <div className="top-row mb-4">
                    <p className="m-0 title">Tickets List<span className="count"> ({ticketsCount})</span></p>
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center"></div>
                        <div className="d-flex align-items-center justify-content-end">
                            <input
                                type="text"
                                className="form-control search-ticket"
                                value=""
                                placeholder="Search Ticket"
                            />
                        </div>
                    </div>
                </div>
                <table className="tickets-table table">
                    <tr>
                        <th>ID</th>
                        <th>Subject</th>
                        <th>Assigned To</th>
                        <th>Created On</th>
                        <th className="text-center">Completed On</th>
                        <th className="text-center">Status</th>
                        <th className="text-center">Action</th>
                    </tr>
                    {
                        tickets?.length > 0 ?
                            tickets?.map(ticket => {
                                return (
                                    <tr>
                                        <td>{ticket.ticket_id}</td>
                                        <td>{ticket.title}</td>
                                        <td>You</td>
                                        <td>
                                            {moment(ticket.createdAt).format("D-MM-YYYY")}
                                        </td>
                                        <td className="text-center">{ticket.completedAt ?
                                            moment(ticket.completedAt).format("D-MM-YYYY")
                                            :
                                            <AiOutlinePlus
                                                size={35}
                                                color="#7F64B3CF" />}</td>
                                        <td
                                            className="status"
                                            onClick={() => onStatusClicked(ticket._id)}
                                        >
                                            <Dropdown>
                                                <Dropdown.Toggle
                                                    className="d-flex align-items-center dropdown-btn text-center m-auto"
                                                >
                                                    {
                                                        ticket.ticket_status == "opened" ?
                                                            <div className="icon-div open">
                                                                <img src="/assets/images/open_sign.png" width="15px" height="15px" />
                                                            </div>
                                                            :
                                                            ticket.ticket_status == "in progress" ?
                                                                <div className="icon-div inprogress">
                                                                    <img src="/assets/images/in_progress_sign.png" width="15px" height="15px" />
                                                                </div>
                                                                :
                                                                ticket.ticket_status == "resolved" ?
                                                                    <div className="icon-div resolved">
                                                                        <img src="/assets/images/resolved_sign.png" width="15px" height="15px" />
                                                                    </div>
                                                                    :
                                                                    ticket.ticket_status == "closed" ?
                                                                        <div className="icon-div inprogress">
                                                                            <img src="/assets/images/in_progress_sign.png" width="15px" height="15px" />
                                                                        </div>
                                                                        :
                                                                        <></>
                                                    }
                                                    <p className="mb-0 ms-1 status-text">{ticket.ticket_status}</p>
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu className="status-dropdown">
                                                    <Dropdown.Item
                                                        className="d-flex align-items-center"
                                                        onClick={() => onStatusSelected(ticket._id, "opened")}
                                                    >
                                                        <BsCircle
                                                            size={11}
                                                        />
                                                        <label className="ms-1">Open</label>
                                                    </Dropdown.Item>
                                                    <Dropdown.Item
                                                        className="d-flex align-items-center"
                                                        onClick={() => onStatusSelected(ticket._id, "in progress")}
                                                    >
                                                        <BsCircle
                                                            size={11}
                                                        />
                                                        <label className="ms-1">In progress</label>
                                                    </Dropdown.Item>
                                                    <Dropdown.Item
                                                        className="d-flex align-items-center"
                                                        onClick={() => onStatusSelected(ticket._id, "resolved")}
                                                    >
                                                        <BsCircle
                                                            size={11}
                                                        />
                                                        <label className="ms-1">Resolved</label>
                                                    </Dropdown.Item>
                                                    <Dropdown.Item
                                                        className="d-flex align-items-center"
                                                        onClick={() => onStatusSelected(ticket._id, "closed")}
                                                    >
                                                        <BsCircle
                                                            size={11}
                                                        />
                                                        <label className="ms-1">Closed</label>
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </td>
                                        <td className="text-center">
                                            <Link
                                                to={"/ticket/" + ticket.createdBy + "?id=" + ticket._id}
                                                className="view-btn"
                                            >View</Link>
                                        </td>
                                    </tr>
                                )
                            })
                            :
                            <p>No tickets found.</p>
                    }
                </table>
                <ReactPaginate
                    breakLabel="..."
                    nextLabel=">"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={5}
                    pageCount={totalPages}
                    previousLabel="<"
                    renderOnZeroPageCount={null}
                    className="pagination"
                    activeClassName="active-page"
                    forcePage={page - 1}
                />
            </div>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
            {/* Same as */}
            <ToastContainer />
        </div>
    )
}

export default AllTickets;